import GalleryDescriptionContainer from "../../../components/miscellaneous/gallery/galleryDescription";

const GalleryDescription = () => {
  return <GalleryDescriptionContainer />;
};

export default GalleryDescription;
